export const PracticalData = [
  {
    title: 'disease_reporting_bloc_component_procedure_amc_main_title',
    descript: [
      {
        titleDescription:
          'disease_reporting_component_procedure_amc_first_title',
        firstDescription:
          'disease_reporting_component_procedure_amc_first_description',
        desc: [
          {
            title: 'disease_reporting_component_procedure_amc_first_choice',
          },
          {
            title: 'disease_reporting_component_procedure_amc_second_choice',
          },
        ],
        secondDescription:
          'disease_reporting_component_procedure_amc_second_description',
      },
      {
        titleDescription:
          'disease_reporting_component_procedure_amc_second_title',
        firstDescription:
          'disease_reporting_component_procedure_amc_second_title_firstDescription',
        desc: [
          {
            title:
              'disease_reporting_component_procedure_amc_second_title_firstChoice',
          },
          {
            title:
              'disease_reporting_component_procedure_amc_second_title_secondChoice',
          },
          {
            title:
              'disease_reporting_component_procedure_amc_second_title_thirdChoice',
          },
          {
            title:
              'disease_reporting_component_procedure_amc_second_title_fourthChoice',
          },
          {
            title:
              'disease_reporting_component_procedure_amc_second_title_fifthChoice',
          },
          {
            title:
              'disease_reporting_component_procedure_amc_second_title_sixthChoice',
          },
          {
            title:
              'disease_reporting_component_procedure_amc_second_title_seventhChoice',
          },
        ],
      },
      {
        titleDescription:
          'disease_reporting_entreprise_bloc_component_procedure_amc_main_title',
        firstDescription:
          'disease_reporting_entreprise_bloc_component_procedure_amc_main_description',
        desc: [],
      },
    ],
  },

  {
    title: 'request_coverage_bloc_main_title',
    descript: [
      {
        titleDescription: 'request_coverage_first_bloc_title',
        firstDescription: 'request_coverage_first_bloc_description',
        desc: [
          {
            title: 'request_coverage_first_bloc_firstStep_title',
            desc: 'request_coverage_first_bloc_firstStep_description',
            descBulle: [
              {
                bulle: 'request_coverage_first_bloc_firstStep_firstBulle',
              },
              {
                bulle: 'request_coverage_first_bloc_firstStep_secondBulle',
              },
              {
                bulle: 'request_coverage_first_bloc_firstStep_thirdBulle',
              },
              {
                bulle: 'request_coverage_first_bloc_firstStep_fourthBulle',
              },
            ],
          },
          {
            title: 'request_coverage_first_bloc_secondStep_title',
            desc: 'request_coverage_first_bloc_secondStep_description',
            descBulle: [],
          },
          {
            title: 'request_coverage_first_bloc_thirdStep_title',
            desc: 'request_coverage_first_bloc_thirdStep_description',
            descBulle: [],
          },
        ],
      },
      {
        titleDescription: 'request_coverage_second_bloc_title',
        firstDescription: 'request_coverage_second_bloc_description',
        desc: [
          {
            descBulle: [
              {
                bulle: 'request_coverage_second_bloc_firstBulle',
              },
              {
                bulle: 'request_coverage_second_bloc_secondBulle',
              },
              {
                bulle: 'request_coverage_second_bloc_thirdBulle',
              },
            ],
          },
        ],
      },
      {
        titleDescription: 'request_coverage_third_bloc_title',
        firstDescription: 'request_coverage_third_bloc_description',
        desc: [],
      },
    ],
  },
  {
    title: 'change_situation_bloc_main_title',
    descript: [
      {
        titleDescription: 'change_situation_first_bloc_title',
        desc: [
          {
            title: 'change_situation_first_bloc_first_check',
            descBulle: [
              {
                bulle: 'change_situation_first_bloc_first_check_firstBulle',
              },
            ],
          },
          {
            title: 'change_situation_first_bloc_second_check',
            descBulle: [
              {
                bulle: 'change_situation_first_bloc_second_check_firstBulle',
              },
            ],
          },
        ],
      },
      {
        titleDescription: 'change_situation_second_bloc_title',
        desc: [
          {
            title: 'change_situation_second_bloc_first_check',
            descBulle: [
              {
                bulle: 'change_situation_second_bloc_first_check_firstBulle',
              },
            ],
          },
          {
            title: 'change_situation_second_bloc_second_check',
            descBulle: [
              {
                bulle: 'change_situation_second_bloc_second_check_firstBulle',
              },
            ],
          },
          {
            title: 'change_situation_second_bloc_third_check',
            descBulle: [
              {
                bulle: 'change_situation_second_bloc_third_check_firstBulle',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'transmission_procedure_main_title',
    descript: [
      {
        titleDescription: 'transmission_procedure_first_bloc_title',
        desc: [
          {
            title: 'transmission_procedure_first_bloc_first_check',
          },
          {
            title: 'transmission_procedure_first_bloc_second_check',
          },
        ],
      },
    ],
  },
  {
    title: 'claims_procedure_main_title',
    descript: [
      {
        titleDescription: 'claims_procedure_first_bloc_title',
        desc: [
          {
            title: 'claims_procedure_first_bloc_first_check',
          },
          {
            title: 'claims_procedure_first_bloc_second_check',
          },
          {
            title: 'claims_procedure_first_bloc_third_check',
          },
        ],
      },
    ],
  },
];
